module.exports = {
  "country": "SE",
  "artist": "Marcus & Martinius",
  "song": "Unforgettable",
  "year": "2024",
  "place": "9",
  "spotify": "5L8C1PZGCpZf8STcN79H5j"
};